import { render, staticRenderFns } from "./detail_list.vue?vue&type=template&id=645f88a0&scoped=true"
import script from "./detail_list.vue?vue&type=script&lang=js"
export * from "./detail_list.vue?vue&type=script&lang=js"
import style0 from "./detail_list.vue?vue&type=style&index=0&id=645f88a0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645f88a0",
  null
  
)

export default component.exports